import selectOption from '@/store/dict/selectOptionDict'
import { ViolationDetail } from '@/api/domain/carsService.js'
// paramsObj.isShowPlateNo 是否展示车牌号列
// paramsObj.isIdClick id是否可点击
export default function (paramsObj) {
  const tableData = {
    columns: [
      {
        name: 'id',
        columnProps: {
          prop: 'id',
          label: '违章单ID',
          width: 100,
        },
        render: ({ row }) => {
          const isPermission = this.judgePermission('vehicle_violation_record_list_detail')
          if (isPermission && paramsObj?.isIdClick !== false) {
            return this.$createElement('el-button', {
              props: {
                type: 'text',
              },
              on: {
                click: () => {
                  isPermission && this.detail(row)
                },
              },
            }, row.id)
          }
          return this.$createElement('span', {}, row.id)
        },
      },
      {
        name: 'plateNo',
        columnProps: {
          prop: 'plateNo',
          label: '车牌号',
          width: 100,
        },
        showColumnItem: paramsObj?.isShowPlateNo !== false,
      },
      {
        name: 'customerName',
        columnProps: {
          prop: 'customerName',
          label: '相关客户',
        },
      },
      {
        name: 'orderTypeDesc',
        columnProps: {
          prop: 'orderTypeDesc',
          label: '相关订单类型',
          width: 110,
        },
      },
      {
        name: 'orderId',
        columnProps: {
          prop: 'orderId',
          label: '相关订单',
        },
      },
      {
        name: 'violationTime',
        columnProps: {
          prop: 'violationTime',
          label: '违章时间',
          width: 160,
        },
      },
      {
        name: 'place',
        columnProps: {
          prop: 'place',
          label: '违章地点',
        },
      },
      {
        name: 'content',
        columnProps: {
          prop: 'content',
          label: '违章行为',
          width: 160,
        },
      },
      {
        name: 'penaltyPoint',
        columnProps: {
          prop: 'penaltyPoint',
          label: '违章扣分',
        },
      },
      {
        name: 'handleState',
        columnProps: {
          prop: 'handleState',
          label: '违章处理',
        },
        getText: ({ row }) => selectOption.processingstatusDict[row.handleState],
      },
      {
        name: 'handleCompleteTime',
        columnProps: {
          prop: 'handleCompleteTime',
          label: '处理时间',
        },
      },
      {
        name: 'penaltyAmount',
        columnProps: {
          prop: 'penaltyAmount',
          label: '违章罚款',
        },
        getText: ({ row }) => this.numberWithCommas(row.penaltyAmount),
      },
      {
        name: 'paymentState',
        columnProps: {
          prop: 'paymentState',
          label: '缴款状态',
        },
        getText: ({ row }) => selectOption.paymentStateList[row.paymentState],
      },
      {
        name: 'dealViolationWay',
        columnProps: {
          prop: 'dealViolationWay',
          label: '处理方式',
        },
        getText: ({ row }) => selectOption.dealViolationWayList[row.dealViolationWay],
      },
      {
        name: 'handleRemarks',
        columnProps: {
          prop: 'handleRemarks',
          label: '处理备注',
        },
      },
      {
        name: 'latestUpdateTime',
        columnProps: {
          width: 160,
          prop: 'latestUpdateTime',
          label: '最后更新时间',
        },
      },
    ],
    apiFn: ViolationDetail,
  }
  return {
    tableData,
  }
}
